// extracted by mini-css-extract-plugin
export var container = "ResearchAndDevelopmentLink-module--container--J4kr8";
export var content = "ResearchAndDevelopmentLink-module--content--tAOjP";
export var title = "ResearchAndDevelopmentLink-module--title--dJKbY";
export var stageText = "ResearchAndDevelopmentLink-module--stageText--19eYI";